import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import normalizeRoomName from '../helpers/normalizeRoomName';
import blackRoom from './assets/rooms/black/black.glb';
import whiteRoom from './assets/rooms/white/room.glb';
import goldRoom from './assets/rooms/gold/scene2.glb';
import { animationService } from './animationService';

class RoomsManagementHub {
  roomsGlb = {};
  roomsWheelMesh = {};
  roomsRouletteCollisionMesh = {};

  rooms = {
    'Black Room': blackRoom,
    'White Room': whiteRoom,
    'Gold Room': goldRoom,
  };

  isRoomsLoaded = false;
  currentRoomName = '';

  constructor() {
    this.loader = new GLTFLoader();
  }

  async downloadRoomsGlb() {
    const roomNames = Object.keys(this.rooms);
    const roomFiles = Object.values(this.rooms);

    const loadPromises = roomFiles.map((roomFile, index) => {
      return new Promise((resolve, reject) => {
        this.loader.load(
          roomFile,
          (gltf) => {
            this.roomsGlb[roomNames[index]] = gltf.scene;

            gltf.scene.traverse((child) => {
              if (child.name === 'table_1' || child.name === 'table_0') {
                this.roomsWheelMesh[roomNames[index]] = child;
              }
              if (child.name === 'Mesh_9_3' || child.name === 'Mesh019_5') {
                console.log('Mesh_9_3 found');
                this.roomsRouletteCollisionMesh[roomNames[index]] = child;
              }
            });
            resolve();
          },
          undefined,
          (error) => {
            console.error(`Error loading room ${roomNames[index]}:`, error);
            reject(error);
          }
        );
      });
    });

    await Promise.all(loadPromises);
    this.isRoomsLoaded = true;
  }

  addRouletteGLBModel(scene, roomName) {
    const normalizedRoomName = normalizeRoomName(roomName);

    Object.values(this.roomsGlb).forEach((room) => (room.visible = false));
    this.roomsGlb[normalizedRoomName].visible = true;
    scene.add(this.roomsGlb[normalizedRoomName]);
    this.currentRoomName = normalizedRoomName;
    animationService.wheel.startRegularRotationAnimation();
  }

  getCurrentRoomWheelMesh() {
    return this.roomsWheelMesh[this.currentRoomName];
  }

  getCurrentRoomsRouletteCollisionMesh() {
    return this.roomsRouletteCollisionMesh[this.currentRoomName];
  }
}

export const roomsManagementHub = new RoomsManagementHub();
